"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTableResizerStore = exports.getTableResizerStore = void 0;
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var withKey = function withKey(id) {
  return "".concat(id, "-icfTableHeaderResizerId");
};
var getTableResizerStore = exports.getTableResizerStore = function getTableResizerStore(id) {
  return JSON.parse(window.localStorage.getItem(withKey(id)));
};
var setTableResizerStore = exports.setTableResizerStore = function setTableResizerStore(id, headers) {
  window.localStorage.setItem(withKey(id), JSON.stringify(headers));
};